import {ComponentProps} from "react";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {LeadFormAskForFullOffer} from "../lead_form/LeadFormAskForFullOffer";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormAskForFullOffer>, "customHeader">;

export const LeadFormModalAskForFullOffer = (props: IProps) => {
    const {formCloseSnapshotRef, handleModalClose} = props;

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalClose}
            title="Zapytaj dewelopera o pełną ofertę"
            testId={OFFER_TEST_IDS.LEAD_FORM.ASK_FOR_FULL_OFFER_FORM}
        >
            <LeadFormAskForFullOffer
                {...props}
                formCloseSnapshotRef={formCloseSnapshotRef}
                handleModalClose={handleModalClose}
                customHeader={null}
                isTwoColumnGrid
            />
        </LeadFormModalWrapper>
    );
};
import {ComponentProps} from "react";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {LeadFormAskForFullOffer} from "../lead_form/LeadFormAskForFullOffer";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormAskForFullOffer>, "customHeader">;

export const LeadFormModalAskForFullOffer = (props: IProps) => {
    const {formCloseSnapshotRef, handleModalClose} = props;

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalClose}
            title="Zapytaj dewelopera o pełną ofertę"
            testId={OFFER_TEST_IDS.LEAD_FORM.ASK_FOR_FULL_OFFER_FORM}
        >
            <LeadFormAskForFullOffer
                {...props}
                formCloseSnapshotRef={formCloseSnapshotRef}
                handleModalClose={handleModalClose}
                customHeader={null}
                isTwoColumnGrid
            />
        </LeadFormModalWrapper>
    );
};
